/**
 * Created by Tukta on 15/7/2560.
 */
import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import CustomerListRow from '../../../components/Customer/CustomerListRow'
import CustomerForm from '../../../components/Customer/CustomerForm'
import CustomerEdit from '../../../components/Customer/CustomerEdit'
import ProfileForm from '../../../components/Customer/ProfileForm'
import { connect } from 'react-redux'
import ProfileListRow from '../ProfileListRow'
import CustomerDocList from '../CustomerDocList/CustomerDocList'
import CustomerDocAdd from '../CustomerDocAdd/CustomerDocAdd'

class CustomerList extends Component{
    constructor (props) {
        super(props)

        this.state = {
            lists: [],
            load_data: true,
            danger: false,
            primary: false,
            primarycustomeredit: false,
            selectCustomer:'',
            customer_id:0,
            action: "บันทึก",
            customer: '' ,
            activeTab: '1',
            user: JSON.parse(this.props.user),
            toggle_profile_form: false,
            profile_form_status: 'add',
            profile_lists: [],
            profile_selected: {},
            toggle_customer_add: false,
            customer_docs: [],
            customer_doc_form_status: 'add',
            customer_doc_selected: {},
        }
        this.togglePrimary= this.togglePrimary.bind(this);
        this.togglePrimaryCustomerEdit= this.togglePrimaryCustomerEdit.bind(this);
        this.toggleProfileForm = this.toggleProfileForm.bind(this);
        this.onSubmitProfile = this.onSubmitProfile.bind(this);
        this.onProfileDelete = this.onProfileDelete.bind(this);
        this.onProfileEdit = this.onProfileEdit.bind(this);
        this.toggleCustomerDocAdd = this.toggleCustomerDocAdd.bind(this);
        this.deleteCustomerDoc = this.deleteCustomerDoc.bind(this);
        this.editCustomerDoc = this.editCustomerDoc.bind(this);
    }

    loadData () {
        axios.get(APIURL + '/customer/')
            .then(res => {
                //alert (res.data.length)
                //console.log(res)
                this.setState({lists: res.data, load_data: false, customer_id: 0, danger: false})
            }).catch(error => {
                //alert (error)
                //console.log(error)
            this.setState({lists: [], load_data: true, customer_id: 0, danger: false})
        })
    }

      toggle(tab) {
        // console.log(tab)
        // console.log(typeof tab)
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          },()=>{
            if(this.state.activeTab === '2' ){
              this.loadProfileData();
            }else if(this.state.activeTab === '3'){
              this.loadCustomerDoc();
            }
          });
        }
      }

    componentDidMount () {
        //if(this.state.load_data)
        this.loadData()
    }

    toggleDanger () {
        this.setState({
            danger: !this.state.danger
        })
    }

    toggleDangerDelete (id) {

        axios.delete(APIURL + '/customer/' + id).then(res => {
            if (res.status === 200) {
                this.loadData()
                this.setState({action: "บันทึก"});
            }
        })
    }

    togglePrimary() {
        this.setState({
            primary: !this.state.primary
        },()=>{
          this.loadData();
        });
    }

    togglePrimaryCustomerEdit() {
        this.setState({
            primarycustomeredit: !this.state.primarycustomeredit
        });
    }

    deleteCustomer (customer) {
        this.setState({customer_id: customer.customer_id})
        this.toggleDanger()
    }

    editCustomer (customer) {
        //this.setState({action: "แก้ไข", customer: customer, customer_id: customer.customer_id});
        this.setState ({selectCustomer:customer})
        this.togglePrimaryCustomerEdit()
        //alert(customer);
    }


    addCustomer (event){
        event.preventDefault()
        let that = this ;
        let customer_name = event.target.customer_name.value
        let customer_lastname = event.target.customer_lastname.value
        let customer_card_id = event.target.customer_card_id.value
        let customer_birth = event.target.customer_birth.value
        let customer_age = event.target.customer_age.value
        let customer_mobile = event.target.customer_mobile.value
        let customer_address = event.target.customer_address.value

        if(customer_name===''){
            return ;
        }
        event.target.customer_name.value = ""
        event.target.customer_lastname.value = ""
        event.target.customer_card_id.value = ""
        event.target.customer_birth.value = ""
        event.target.customer_age.value = ""
        event.target.customer_mobile.value = ""
        event.target.customer_address.value = ""

        axios.post(APIURL + '/customer/', {
            customer_name: customer_name,
            customer_lastname: customer_lastname,
            customer_card_id : customer_card_id,
            customer_birth: customer_birth,
            customer_age : customer_age,
            customer_mobile: customer_mobile,
            customer_address : customer_address,
            status_field: 'show',
            username: 'admin'
        })
            .then(function (response) {
                //console.log(response)
                that.loadData()
                that.setState({ customer: '', customer_id: 0, action: "บันทึก"})
            })
            .catch(function (error) {
                //console.log(error)
            })
    }

    updateCustomer(event){
        event.preventDefault()

        let that = this ;
        let customer_id = event.target.customer_id.value ;
        let customer_name = event.target.customer_name.value
        let customer_lastname = event.target.customer_lastname.value
        let customer_card_id = event.target.customer_card_id.value
        let customer_birth = event.target.customer_birth.value
        let customer_age = event.target.customer_age.value
        let customer_mobile = event.target.customer_mobile.value
        let customer_address = event.target.customer_address.value
        //alert(customer_name);
      let guarantor_name = event.target.guarantor_name.value
      let guarantor_address = event.target.guarantor_address.value
      let guarantor_mobile = event.target.guarantor_mobile.value

        if(customer_name===''){
            return ;
        }
        event.target.customer_name.value = ""
        event.target.customer_lastname.value = ""
        event.target.customer_card_id.value = ""
        event.target.customer_birth.value = ""
        event.target.customer_age.value = ""
        event.target.customer_mobile.value = ""
        event.target.customer_address.value = ""
      //
      event.target.guarantor_name.value = ""
      event.target.guarantor_address.value = ""
      event.target.guarantor_mobile.value = ""

        axios.put(APIURL + '/customer/'+customer_id, {
            customer_id:customer_id,
            customer_name: customer_name,
            customer_lastname: customer_lastname,
            customer_card_id : customer_card_id,
            customer_birth: customer_birth,
            customer_age : customer_age,
            customer_mobile: customer_mobile,
            customer_address : customer_address,
            status_field: 'show',
            username: 'admin',
            guarantor_name: guarantor_name,
            guarantor_address: guarantor_address,
            guarantor_mobile: guarantor_mobile
        })
            .then(function (response) {
                // console.log(response)
                that.loadData()
                that.setState({ customer: '', customer_id: 0, action: "บันทึก"})
                /*that.setState({
                    primarycustomeredit: !that.state.primarycustomeredit
                });*/
                that.togglePrimaryCustomerEdit();
            })
            .catch(function (error) {
                // console.log(error)
            })
    }

    changeCustomer(event){
        let xname =event.target.name
        if(xname==="customer_name"){
            this.setState ({customer:{
                customer_name: event.target.value
            }})
        }else if(xname==="customer_lastname"){
            this.setState ({customer:{
                customer_lastname: event.target.value
            }})
        }else if(xname==="customer_card_id"){
            this.setState ({customer:{
                customer_card_id: event.target.value
            }})
        }else if(xname==="customer_birth"){
            this.setState ({customer:{
                customer_birth : event.target.value
            }})
        }else if(xname==="customer_age"){
            this.setState ({customer:{
                customer_age : event.target.value
            }})
        }else if(xname==="customer_mobile"){
            this.setState ({customer:{
                customer_mobile : event.target.value
            }})
        }else if(xname==="customer_address"){
            this.setState ({customer:{
                customer_address : event.target.value
            }})
        }

    }

    onSearch(){
      var search_text = this.refs.input_search.value

      if(search_text==='')
          return;

      axios.get( APIURL + '/customer/search/'+search_text )
        .then(res => {
          this.setState({lists: res.data, load_data: false, customer_id: 0, danger: false})
        }).catch(error => {
          this.setState({lists: [], load_data: true, customer_id: 0, danger: false})
      })

    }

    onRefresh(){
      this.refs.input_search.value = ''
      this.loadData()
    }

    //Profile
    toggleProfileForm() {
      this.setState({
        toggle_profile_form: !this.state.toggle_profile_form
      },()=>{
        // this.loadData();
      });
    }

    toggleCustomerDocAdd() {
      this.setState({
        toggle_customer_add: !this.state.toggle_customer_add
      });
    }

    loadProfileData() {
      axios.get(APIURL + '/profile/')
        .then(res => {
          this.setState({profile_lists: res.data})
        }).catch(error => {
        this.setState({profile_lists: []})
      })
    }

     onSubmitProfile(event) {
       event.preventDefault();
       var profile_from = event.target.profile_from.value;
       var profile_address = event.target.profile_address.value;
       var profile_fn1 = event.target.profile_fn1.value;
       var profile_fn2 = event.target.profile_fn2.value;
       var profile_fn3 = event.target.profile_fn3.value;
       var profile_name = event.target.profile_name.value;
       var profile_ncb1 = event.target.profile_ncb1.value;
       var profile_guarantor1 = event.target.profile_guarantor1.value;
       var profile_guarantor_ncb1 = event.target.profile_guarantor_ncb1.value;
       var profile_guarantor2 = event.target.profile_guarantor2.value;
       var profile_guarantor_ncb2 = event.target.profile_guarantor_ncb2.value;
       var user = this.state.user.user;
       var customer_id = event.target.customer_id.value;
       var profile_id = event.target.profile_id.value;

       if(profile_name==='') {
         alert('กรุณากรอกโปรไฟล์ลูกค้า');
         return;
       }

       const data = {
         profile_from: profile_from,
         profile_address: profile_address,
         profile_fn1: profile_fn1,
         profile_fn2: profile_fn2,
         profile_fn3: profile_fn3,
         profile_name: profile_name,
         profile_ncb1: profile_ncb1,
         profile_guarantor1: profile_guarantor1,
         profile_guarantor_ncb1: profile_guarantor_ncb1,
         profile_guarantor2: profile_guarantor2,
         profile_guarantor_ncb2: profile_guarantor_ncb2,
         user: user,
         customer_id: customer_id,
         profile_id: profile_id
       }
       // console.log(data);
       if(this.state.profile_form_status === 'add') {
           axios.post(APIURL + '/profile', data)
           .then((res) => {
             // console.log(res);
             if (res.status === 200) {
               this.toggleProfileForm();
               this.loadProfileData();
             }
           })
           .catch((err) => {
             // console.log(err);
           });
       }else{
         axios.put(APIURL + '/profile/'+profile_id, data)
           .then((res) => {
             // console.log(res);
             if (res.status === 200) {
               this.toggleProfileForm();
               this.loadProfileData();
             }
           })
           .catch((err) => {
             console.log(err);
           });
       }
     }

    onProfileDelete(profile) {
      // alert('onProfileDelete');
      var profile_id = profile.profile_id;
      //console.log('profile_id='+profile_id);
      if(window.confirm('คุณต้องการลบโปรไฟล์ '+profile_id+ ' ใช่หรือไม่ ?')) {
        axios.delete(APIURL + '/profile/' + profile_id)
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              //this.toggleProfileForm();
              this.loadProfileData();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

    }

    onProfileEdit(profile) {
      this.setState({
        profile_form_status: 'edit',
        toggle_profile_form: !this.state.toggle_profile_form,
        profile_selected: profile
      });
    }

    addCustomerDoc(event){
      event.preventDefault();
      var that = this ;
      var customer_id = event.target.customer_id.value
      var doc_detail = event.target.doc_detail.value
      var form_status = event.target.form_status.value
      var customer_doc_id = event.target.customer_doc_id.value

      if(form_status === 'add')
      {
        const data = new FormData();
        data.append('file', event.target.doc_file.files[0], event.target.doc_file.files[0].name);
        data.append('customer_id', customer_id);
        data.append('doc_detail', doc_detail);
        data.append('user_created', this.state.user.user);

        axios.post(APIURL + '/customer_doc', data)
          .then(function (response) {
            //console.log(response)
            //that.loadCarDocData()
            that.loadCustomerDoc()
            that.toggleCustomerDocAdd()
          })

      }else if(form_status === 'edit') {
        const data = new FormData();
        data.append('file', event.target.doc_file.files[0], event.target.doc_file.files[0].name);
        data.append('customer_id', customer_id);
        data.append('doc_detail', doc_detail);
        data.append('user_created', this.state.user.user);

        axios.post(APIURL + '/customer_doc/edit/'+customer_doc_id, data)
          .then(function (response) {
            //console.log(response)
            //that.loadCarDocData()
            that.loadCustomerDoc()
            that.toggleCustomerDocAdd()
          })

      }

    }

    addCustomerDocNoFile(event) {
      event.preventDefault();
      var that = this ;
      var customer_id = event.target.customer_id.value
      var doc_detail = event.target.doc_detail.value
      var form_status = event.target.form_status.value
      var customer_doc_id = event.target.customer_doc_id.value

      var data = {
        customer_id: customer_id,
        doc_detail: doc_detail,
        user_created: this.state.user.user
      }

      if(form_status === 'add') {
        axios.post(APIURL + '/customer_doc/nofile', data)
          .then(function (response) {
            //console.log(response)
            //that.loadCarDocData()
            that.loadCustomerDoc()
            that.toggleCustomerDocAdd()
          })
      }else if(form_status === 'edit') {
        // alert('form_status='+form_status+' , customer_doc_id='+customer_doc_id)
        axios.put(APIURL + '/customer_doc/edit/nofile/'+customer_doc_id, data)
          .then(function (response) {
            //console.log(response)
            //that.loadCarDocData()
            that.loadCustomerDoc()
            that.toggleCustomerDocAdd()
          })
      }

    }



    loadCustomerDoc() {
      // customer_docs
      axios.get(APIURL+'/customer_doc')
        .then((res) => {
          //console.log('====loadCustomerDoc')
          //console.log(res.data)
          this.setState({customer_docs: res.data})
          //that.loadCarDocData()
        })
    }

    deleteCustomerDoc(customer_doc) {
      if(window.confirm('คุณต้องการลบเอกสารลูกค้า '+ customer_doc.customer_doc_id + ' ใช่หรือไม่ ?')) {
        var customer_doc_id= customer_doc.customer_doc_id
        var data = {
          doc_file: customer_doc.doc_file
        }
        axios.post(APIURL+'/customer_doc/delete/'+customer_doc_id,data)
          .then((res) => {
            this.loadCustomerDoc()
          })
      }
    }
    //
    editCustomerDoc(customer_doc) {
      //open modal for edit
      this.setState({
        customer_doc_selected: customer_doc,
        customer_doc_form_status: 'edit'
      },()=>this.toggleCustomerDocAdd());

    }


    render(){

        //let customer = this.customer;

        return (
          <div className="col-md-12 mb-4">
            <Nav tabs>

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  <i className="icon-options-vertical"></i> ข้อมูลลูกค้าใหม่
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  <i className="icon-badge"></i> โปรไฟล์ลูกค้า
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                  <i className="icon-docs"></i> เอกสารลูกค้า
                </NavLink>
              </NavItem>

            </Nav>

            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <div className="card card-accent-info">
                      <div className="card-header">
                        <strong> รายชื่อลูกค้า </strong>

                        <input
                          onChange={this.onSearch.bind(this)}
                          ref="input_search"
                          style={styles.inputSearch}
                          className="form-control"
                          placeholder="ค้นหาตามชื่อ หรือ เบอร์โทร"
                          type="text"
                        />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <button className="btn btn-primary"
                                style={styles.buttonHeight}
                                onClick={this.onRefresh.bind(this)}
                        >
                          <i className="icon-refresh"></i>
                        </button>

                        <button type="button" onClick={this.togglePrimary} className="btn btn-primary float-right">
                          <i className="icon-user-follow"></i>&nbsp;เพิ่มข้อมูลลูกค้า
                        </button>
                        <Modal isOpen={this.state.primary} toggle={this.togglePrimary} className={'modal-lg ' + this.props.className}>
                          <ModalBody>
                            <CustomerForm onToggle={this.togglePrimary}/>
                          </ModalBody>
                        </Modal>
                      </div>

                      <CustomerListRow
                        customer_list={this.state.lists}
                        customerCallbacks={
                          {

                            delete: this.deleteCustomer.bind(this),
                            edit: this.editCustomer.bind(this),

                          }
                        }

                      />

                      <Modal isOpen={this.state.primarycustomeredit} toggle={this.togglePrimaryCustomerEdit} className={'modal-lg ' + this.props.className}>
                        <ModalBody>
                          <CustomerEdit
                            onToggle={this.togglePrimaryCustomerEdit}
                            customer={this.state.selectCustomer}
                            onCustomerSubmit={
                              {
                                add: this.addCustomer.bind(this),
                                update: this.updateCustomer.bind(this),
                                change: this.changeCustomer.bind(this)
                              }
                            }
                            actionType={this.state.action}

                            customers={this.state.customer}

                          />
                        </ModalBody>
                      </Modal>


                      <Modal isOpen={this.state.danger} toggle={this.toggleDanger.bind(this)}
                             className={'modal-danger'}>
                        <ModalHeader toggle={this.toggleDanger.bind(this)}>ลบข้อมูล</ModalHeader>
                        <ModalBody>
                          <strong> คุณต้องการลบข้อมูล id={this.state.customer_id} ใช่หรือไม่ ?? </strong>
                          <br />(ข้อมูลจะไม่สามารถกู้คืนได้)
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary"
                                  onClick={this.toggleDangerDelete.bind(this, this.state.customer_id)}>ตกลง</Button>{' '}
                          <Button color="secondary" onClick={this.toggleDanger.bind(this)}>ยกเลิก</Button>

                        </ModalFooter>
                      </Modal>

                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="2" >
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <strong>โปรไฟล์ลูกค้า</strong>
                        {/*<input
                          onChange={this.onSearch.bind(this)}
                          ref="input_search"
                          style={styles.inputSearch}
                          className="form-control"
                          placeholder="ค้นหาตามชื่อ หรือ เบอร์โทร"
                          type="text"
                        />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button className="btn btn-primary"
                                style={styles.buttonHeight}
                                onClick={this.onRefresh.bind(this)}
                        >
                          <i className="icon-refresh"></i>
                        </button>*/}

                        <button type="button" onClick={()=>{
                          this.setState({
                            profile_form_status: 'add',
                            toggle_profile_form: !this.state.toggle_profile_form
                          });

                        }} className="btn btn-primary float-right">
                          <i className="icon-user-follow"></i>&nbsp;เพิ่มโปรไฟล์ลูกค้า
                        </button>

                        <Modal isOpen={this.state.toggle_profile_form} toggle={this.toggleProfileForm} className={'modal-lg ' + this.props.className}>
                          <ModalBody>
                            <ProfileForm
                              profile_selected={this.state.profile_selected}
                              form_status={this.state.profile_form_status}
                              onToggle={this.toggleProfileForm}
                              onSubmit={this.onSubmitProfile}
                            />
                          </ModalBody>
                        </Modal>

                      </div>

                      <ProfileListRow
                         profile_lists = {this.state.profile_lists}
                         onProfileDelete={this.onProfileDelete}
                         onProfileEdit={this.onProfileEdit}
                      />


                    </div>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <strong>เอกสารลูกค้า</strong>
                        <button className="btn btn-primary float-right"  onClick={() => {
                          this.setState({
                            customer_doc_form_status: 'add'
                          },() => {
                            this.toggleCustomerDocAdd()
                          })
                        }} >
                          <i className="icon-plus"></i>&nbsp; เพิ่มเอกสาร
                        </button>
                      </div>

                      <div className="card-block">
                         <CustomerDocList
                           customer_docs={this.state.customer_docs}
                           onDelete={this.deleteCustomerDoc}
                           onEdit={this.editCustomerDoc}
                         />
                      </div>

                      <Modal isOpen={this.state.toggle_customer_add} toggle={this.toggleCustomerDocAdd} className={'modal-lg ' + this.props.className}>
                        <ModalBody>
                          <CustomerDocAdd
                            onToggle={this.toggleCustomerDocAdd}
                            onCustomerDocSubmit={
                              {
                                add: this.addCustomerDoc.bind(this),
                                cancel: this.toggleCustomerDocAdd,
                                addNoFile: this.addCustomerDocNoFile.bind(this),
                              }
                            }
                            form_status = {this.state.customer_doc_form_status}
                            customer_doc_selected={this.state.customer_doc_selected}
                          />
                        </ModalBody>
                      </Modal>

                    </div>
                  </div>
                </div>
              </TabPane>

            </TabContent>

          </div>
        );
    }
}

const styles = {
  inputSearch: {
    marginLeft: 20,
    width: 300,
    display: 'inline'
  },

  buttonHeight: {
    height: 32,
    paddingTop:0,
    paddingBottom:0,
    display: 'inline',
    marginTop: '-0.35rem'
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(CustomerList);
